export const contactsData = {
    email: 'abdullahshayan.cse@gmail.com',
    phone: '+8801761926292',
    address: 'Daffodil Smart City,Bangladesh ',

    sheetAPI: 'https://sheetdb.io/api/v1/v6fi34uvbzsxn'
}